import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { ComparisonSection } from './components/ComparisonSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-brand-main font-sans text-brand-text selection:bg-brand-ochre/30" data-id="element-0" data-mp="3ijxqiu0iq6lh">
      <AnnouncementBar data-id="element-1" data-mp="3mlayb9n68jv1" />
      <main data-id="element-2" data-mp="3mkhlbqxmcy4g">
        <HeroSection data-id="element-3" data-mp="3mk84asujy1aw" />
        <StatsBar data-id="element-4" data-mp="3mjg9vlcoy9m7" />
        <TransformationSection data-id="element-5" data-mp="3rc9f0ac2njyt" />
        <ComparisonSection data-id="element-6" data-mp="3rbzo8kj7d8s2" />
        <PainPointsSection data-id="element-7" data-mp="3rcswjpxt86cb" />
        <KitContentsSection data-id="element-8" data-mp="3relv0hy9rk98" />
        <InstantAccessSection data-id="element-9" data-mp="6hq1ea16ddl" />
        <BonusesSection data-id="element-10" data-mp="4n7u7q58zd7" />
        <PricingSection data-id="element-11" data-mp="82jf0klzq9v" />
        <GuaranteeSection data-id="element-12" data-mp="2zld0746gb58w" />
        <TestimonialsSection data-id="element-13" data-mp="2zm4ywnvchj3e" />
        <FAQSection data-id="element-14" data-mp="2zmwguvw0rib7" />
        <FinalCTASection data-id="element-15" data-mp="2zng1wlgyumtg" />
      </main>
      <Footer data-id="element-16" data-mp="33lx0ggmbmoz9" />
    </div>;
}